// src/config.js
export const status_effects = [
    {
        "name": "双难守护",
        "identifier": "double_difficulty_guardian_buff_effect",
        "description": "能够抵御雷电和毒气的伤害"
    },
    {
        "name": "葛伦科守护",
        "identifier": "gronco_guardian_buff_effect",
        "description": "能够抵御物理伤害"
    },
    {
        "name": "重型葛伦科守护",
        "identifier": "heavy_gronco_buff_effect",
        "description": "能够更多抵御物理伤害"
    },
    {
        "name": "等离子守护",
        "identifier": "plasma_guardian_buff_effect",
        "description": "能够抵御真伤并有概率给予反击"
    },
    {
        "name": "风行者",
        "identifier": "whisper_of_the_wind_buff_effect",
        "description": "能与风同行, 自由自在地飞翔于天际, 探索未知的世界."
    },
    {
        "name": "风之轻语",
        "identifier": "windrunner_buff_effect",
        "description": "仿佛拥有风之力量, 轻盈地穿梭于战场, 留下一阵阵风的低语."
    }
];